
const newModel = () => {
    return {
        thethaoGiaithidauId: null,
        ten: null,
        hinhAnh: null,
        linkHinhAnh: null,
        tenFileHinhAnh: null,
        diaDiem: null,
        thoiganTochuc: null,
        thethaoNhomgiaiId: null,
        tenThethaoNhomgiai: null,
        idKy: null,
        tenKy: null,
        moTa: null,
        ghiChu: null,
        stt: null,
        enabled: null,
        dateCreated: null,
        userCreated: null,
        dateModified: null,
        userModified: null,
        isDeleted: null,
        userDeleted: null,
        dateDeleted: null,
        tenUserCreated: null,
        tenUserModified: null,
        tenUserDeleted: null

    }
}

const newFEModel = () => {
    return {
        thethaoGiaithidauId: null,
        ten: null,
        hinhAnh: null,
        linkHinhAnh: null,
        tenFileHinhAnh: null,
        diaDiem: null,
        thoiganTochuc: null,
        thethaoNhomgiaiId: null,
        idKy: null,
        moTa: null,
        ghiChu: null,
        stt: "0",
        enabled: true,
    }
}

const fromJson = (item) => {
    return {
        thethaoGiaithidauId: item.thethaoGiaithidauId,
        ten: item.ten,
        hinhAnh: item.hinhAnh,
        linkHinhAnh: item.linkHinhAnh,
        tenFileHinhAnh: item.tenFileHinhAnh,
        diaDiem: item.diaDiem,
        thoiganTochuc: item.thoiganTochuc,
        thethaoNhomgiaiId: item.thethaoNhomgiaiId,
        tenThethaoNhomgiai: item.tenThethaoNhomgiai,
        idKy: item.idKy,
        tenKy: item.tenKy,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
        dateCreated: item.dateCreated,
        userCreated: item.userCreated,
        dateModified: item.dateModified,
        userModified: item.userModified,
        isDeleted: item.isDeleted,
        userDeleted: item.userDeleted,
        dateDeleted: item.dateDeleted,
        tenUserCreated: item.tenUserCreated,
        tenUserModified: item.tenUserModified,
        tenUserDeleted: item.tenUserDeleted,
    }
}

const parseModeltoFEModel = (item) => {
    return {
        thethaoGiaithidauId: item.thethaoGiaithidauId,
        ten: item.ten,
        hinhAnh: item.hinhAnh,
        linkHinhAnh: item.linkHinhAnh,
        tenFileHinhAnh: item.tenFileHinhAnh,
        diaDiem: item.diaDiem,
        thoiganTochuc: item.thoiganTochuc,
        thethaoNhomgiaiId: item.thethaoNhomgiaiId,
        idKy: item.idKy,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const errors = () => {
    return {
        thethaoGiaithidauId: null,
        ten: null,
        hinhAnh: null,
        linkHinhAnh: null,
        tenFileHinhAnh: null,
        diaDiem: null,
        thoiganTochuc: null,
        thethaoNhomgiaiId: null,
        idKy: null,
        moTa: null,
        ghiChu: null,
        stt: null,
        enabled: null,
        enabledDisplay: null,
        iocId: null,
        iocEnabled: null,
        iocEnabledDisplay: null,
        iocDateUpdated: null,
    }
}

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        ten: null,
        idKy: null,
        thethaoNhomgiaiId: null,
        enabled: null,
    }
}

const newSearchModel = () => {
    return {
        ten: null,
        idKy: null,
        thethaoNhomgiaiId: null,
        enabled: null,
    }
}

export const giaiThiDauTheThaoVHModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    newPagingSearchModel,
    newSearchModel,
    errors,
}


